import { TFunction } from "i18next";
import { ProspectionServicePriceMode } from "@/interfaces";
import { formatCurrency } from "@/utils/currency";

/**
 * Sub-line shown under a prospection pricing option. Capped seasonal services state
 * their included visits (and the per-extra-visit rate when set) instead of the generic
 * "unlimited" blurb; every other mode falls back to its slug-based description.
 */
export function describePriceMode(
  mode: ProspectionServicePriceMode,
  t: TFunction,
): string | undefined {
  if (mode.visit_cap != null) {
    if (mode.overage_rate != null) {
      return t("fe.pages.flow.steps.contract.price-mode-visit-cap-overage", {
        count: mode.visit_cap,
        rate: formatCurrency(mode.overage_rate),
      });
    }

    return t("fe.pages.flow.steps.contract.price-mode-visit-cap", {
      count: mode.visit_cap,
    });
  }

  // i18next returns the key itself when there's no translation for this slug,
  // so only return a description when a real one exists.
  const descriptionKey = `fe.pages.flow.steps.contract.price-mode-description.${mode.slug}`;
  const description = t(descriptionKey);

  return description === descriptionKey ? undefined : description;
}
